import Resource from '@/api/resources/Resource'

class CommonIncidentServices extends Resource {
    async search(params) {
        const response = await this.axios.get('/common/incidents/search', { params })
        return response.data
    }
}

export default new CommonIncidentServices()
